// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2hvv8","clinicsSelect":"styles_clinicsSelect__3cT2y"};